module.exports = __webpack_public_path__ + "static/media/bowman_patton.d89d8829.png";